module.exports = __webpack_public_path__ + "img/document.a6836e1d.svg";